import React from "react";
import { defaultSelectDateRange } from "../AtSelectPeriod/AtSelectPeriod";
import { differenceInDays } from "date-fns";
import { es, enUS, pt } from "react-date-range/src/locale/index.js";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const locales = { es: es, en: enUS, pt: pt };

export function DateRangePicker({
    changePeriodFn,
    dateRangeFromParent,
    minDate,
    maxDate,
    showMonthAndYearPickers = false,
    showDateDisplay = true,
    showMonthArrow = false,
    onShownDateChange,
}) {
    const [dateRange, setDateRange] = React.useState(
        dateRangeFromParent ?? defaultSelectDateRange
    );
    const { t } = useTranslation()

    function handleChangeCustomPeriod(range) {
        const selectedDateRange = range.selection;
        if (
            differenceInDays(
                selectedDateRange.endDate,
                selectedDateRange.startDate
            ) > 31
        ) {
            toast.error("El rango de fechas no puede ser mayor a 31 días");
            return;
        }
        setDateRange(selectedDateRange);
        const text = `Custom: ${format(
            dateRange.startDate,
            "dd/MM/yyyy"
        )} - ${format(dateRange.endDate, "dd/MM/yyyy")}`;
        const period = {
            value: "custom",
            statePeriod: selectedDateRange,
            text,
            period: "c",
        };
        changePeriodFn(period);
    }

    return (
        <DateRange
            maxDate={maxDate ?? new Date()}
            minDate={minDate}
            locale={locales[t.lng] || locales['en']}
            onChange={handleChangeCustomPeriod}
            moveRangeOnFirstSelection={false}
            ranges={[dateRange]}
            className={"PreviewArea"}
            showMonthAndYearPickers={showMonthAndYearPickers}
            showDateDisplay={showDateDisplay}
            rangeColors={["#0B1738"]}
            showMonthArrow={showMonthArrow}
            onShownDateChange={onShownDateChange}
        />
    );
}
